import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ArticleImages",
    component: () => (__SERVER__ ? require("./article-images-view") : import("./article-images-view"))
});

export default definition;
